import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Text, Box } from "sprout-ui-primitives";
const StyledBox = styled(Box)`
  &:first-of-type {
    border-top: 0;
  }
`;
const SelectablesGroup = (props)=>{
    const { heading , children , py  } = props;
    return /*#__PURE__*/ _jsxs(StyledBox, {
        py: py || "16px",
        borderTopStyle: "solid",
        borderTopColor: "white.12",
        borderTopWidth: "1px",
        children: [
            heading && /*#__PURE__*/ _jsx(Text, {
                fontWeight: "bold",
                fontSize: 1,
                p: "0 8px 8px",
                color: "yellow.200",
                children: heading.toUpperCase()
            }),
            children
        ]
    });
};
export default SelectablesGroup;
